import React, { useState } from 'react'
import Field from '../components/Field'
import Modal from '../components/Modal';
import TextArea from '../components/TextArea';
import { getAuthHeaders } from '../services/authAPI';
import moment from 'moment';
import "moment/locale/fr";
import { PDFDownloadLink } from "@react-pdf/renderer";
import LabelDocument from "../components/Label";

export default function LabelPage() {

    const [containersInput, setContainersInput] = useState("");
    const [containers, setContainers] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [token, setToken] = useState("");
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(false);
    
    console.log("Étiquette du " + moment().locale("fr").format("ddd Do MMM"))

    const TYPE_LABELS = {
        locker: "consigne",
        parcel_shop: "commerce"
    };


    async function handleSubmit(){
        setLoading(true);
        const containerList = containersInput
            .split("\n")
            .map(line => line.trim())
            .filter(line => line !== "");


        console.log(JSON.stringify(containerList))
        try {
            const response = await fetch("https://api.harpon.leyos.fr/api/fetch/bags", {
                method: "POST",
                headers: {
                    ...getAuthHeaders(),
                    "Content-Type": "application/json",
                    "Authorization-Client": token
                },
                body: JSON.stringify(containerList)
            });
            if (response.ok){
                const data = await response.json();
                setContainers(Array.isArray(data) ? data : [data]);
                setShowModal(false);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    const filteredContainers = containers.filter(
        (container) =>
            container.name
                ?.toLowerCase()
                .includes(search.toLowerCase()) ||
            container.container_label_code
                ?.toLowerCase()
                .includes(search.toLowerCase()) ||
            container.point_to_code
                ?.toLowerCase()
                .includes(search.toLowerCase()),
    );
    return (
        <>
            <Modal
                title={"Générer"}
                body={
                    <>
                        <Field
                            name="token"
                            label="Token"
                            value={token}
                            onChange={(e) => {setToken(e.target.value)}}
                            type="text"
                        />
                        <TextArea
                            name="containers"
                            label="Sacs"
                            value={containersInput}
                            onChange={(e) => setContainersInput(e.target.value)}
                        />
                    </>
                }
                button={{
                    close:"Annuler",
                    valid:"Créer"
                }}
                showModal={showModal}
                setShowModal={setShowModal}
                onSubmit={handleSubmit}
            />

            <section>
                <div className="card md-4">
                    <div className="card-header py-3">
                        <div className="row py-3">
                            <div className="col-sm-6 text-center text-sm-start">
                                <h5 className="mb-4 mb-sm-0 mt-2">
                                    Création des étiquettes
                                </h5>
                            </div>
                            <div className="col-sm-6 text-center text-sm-end">
                                {containers.length > 0 && !loading && (
                                    <PDFDownloadLink
                                        document={<LabelDocument bags={containers} />}
                                        fileName={
                                            "Étiquette du " + moment()
                                                .locale("fr")
                                                .format("ddd Do MMM [à] HH:mm")
                                                .replace(/\.\s?/g, " ")
                                                .trim()
                                        }
                                        className="btn btn-link me-1"
                                        data-mdb-ripple-init
                                        data-ripple-color="primary"
                                    >
                                        {({ loading: pdfLoading }) => pdfLoading ? (
                                            "Création du PDF..."
                                        ) : (
                                            <>
                                                <i className="fas fa-download me-2"></i>
                                                Télécharger
                                            </>
                                        )}
                                    </PDFDownloadLink>
                                )}
                                <button
                                    type="button"
                                    className="btn btn-primary me-2"
                                    onClick={() => setShowModal(true)}
                                >
                                    Générer
                                    <i className="fas fa-plus ms-2"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    {containers.length > 0 &&
                        <div className="card-body py-5 px-5">
                            <div className="d-flex align-items-center mb-4">
                                <div className="flex-grow-1">
                                    <Field
                                        name="search"
                                        label="Rechercher"
                                        value={search}
                                        onChange={(e) => {
                                            setSearch(e.target.value);
                                        }}
                                        type="text"
                                        margin={false}
                                    />
                                </div>
                            </div>
                            <table className="table table-hover align-middle mb-0 bg-white">
                                <thead className="bg-light">
                                    <tr className='text-center'>
                                        <th>#</th>
                                        <th>Sac</th>
                                        <th>Hub</th>
                                        <th>Type</th>
                                        <th>Point</th>
                                        <th>Commerce</th>
                                        <th>Adresse</th>
                                        <th>Tournée</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredContainers.map((container, index) => (
                                        <tr className="text-center" key={container.container_label_code}>
                                            <td>{index + 1}</td>
                                            <td>{container.container_label_code}</td>
                                            <td>{container.destination_hub_code}</td>
                                            <td>{TYPE_LABELS[container.point_to_type]}</td>
                                            <td>{container.point_to_code}</td>
                                            <td>{container.name}</td>
                                            <td>
                                                {container.address}{container.address && ', '}{container.city}
                                            </td>
                                            <td>
                                                <div className="d-flex align-items-center">
                                                    <div>
                                                        <p className="fw-bold mb-1">
                                                            {container.routes?.[0]
                                                                ? container.routes[0].route_name + " #" + container.routes[0].sequence_in_route
                                                                : ""}
                                                        </p>
                                                        <p className="text-muted mb-0">
                                                            {container.routes?.[0]
                                                                ? moment(container.routes[0].scheduled_for)
                                                                    .locale("fr")
                                                                    .format("ddd Do MMM")
                                                                : ""}
                                                        </p>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    }
                </div>
            </section>
        </>
    )
}